import { render, staticRenderFns } from "./ExamRank.vue?vue&type=template&id=6c3e24cd&scoped=true"
import script from "./ExamRank.vue?vue&type=script&lang=js"
export * from "./ExamRank.vue?vue&type=script&lang=js"
import style0 from "./ExamRank.vue?vue&type=style&index=0&id=6c3e24cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e24cd",
  null
  
)

export default component.exports